import { useMemo, useState } from "react";
import { useParams } from 'react-router-dom'
import { makeCoreGetRequest } from 'utils/api'
import { Table } from 'components/core-ui/Table'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { columns, drawerFilters } from './helpers'
import { toTableRowItems } from './serializers'
import { FormInfoItems } from 'components/core-ui/FormInfoItems'
import { TableContainer } from "@mui/material";

const EditDetails = ({ isHistorical }) => {
  const { showNotification } = useNotification()
  const { id } = useParams()
  const [tableItems, setTableItems] = useState<any[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [infoData, setInfoData] = useState(null)
  const [supportCodeOptions, setSupportCodeOptions] = useState([])
  const [productCodeOptions, setProductCodeOptions] = useState([])

  const filters = useMemo(
    () => drawerFilters(supportCodeOptions, productCodeOptions),
    [supportCodeOptions, productCodeOptions]
  )

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const baseUrl = isHistorical
        ? `/shop-reception/deliveryTicketArchive/details/${id}`
        : `/shop-reception/deliveryTicket/details/${id}`

      const hasFilters = tableFilters.some(tableFilter => tableFilter.value)

      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: hasFilters ? `${baseUrl}/filter` : baseUrl,
          extraCustomUrlParams: [{ name: 'tab', value: 'edit' }],
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.productSupportModelList || []))
      setTotalCount(response.page)
      setInfoData({ externalTicketId: response.externalTicketId })

      if (response.filters) {
        setSupportCodeOptions(response.filters.supportCodeSet || [])
        setProductCodeOptions(response.filters.productCodeSet || [])
      }

      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  return (
    <>
      <FormInfoItems items={[{ label: 'Bon de livrare:', name: infoData?.externalTicketId }]} />
      <TableContainer style={{ marginTop: 15 }}>
        <Table
          hideCheckbox
          columns={columns}
          items={tableItems}
          fetchData={fetchData}
          isLoading={isLoading}
          totalCount={totalCount}
          shouldRefreshData={shouldRefreshData}
          setShouldRefreshData={setShouldRefreshData}
          filters={filters}
          disableSorting
          disablePagination
          filtersLabel="Filtreaza"
          filtersButtonLabel="Filtreaza"
          appliedFiltersLabel="Filtre"
          cancelFiltersButtonLabel="Anuleaza"
          applyFiltersButtonLabel="Aplica"
          hasStickyHeader
          maxHeight={600}
        />
      </TableContainer>
    </>
  )
}

export default EditDetails
